// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32kqT","name":"Header_name__3-ZNs","birthday":"Header_birthday__pwdn2","skeleton":"Header_skeleton__3rgOE"};